module.exports = __webpack_public_path__ + "static/invest-trade-poster-70aa2db9c01a1169ed214ceb360dbd80.png";